import request from '@/utils/request'

export function addOrderList(data) {
  return request({
    url: '/add_order_list',
    method: 'post',
    data
  })
}

export function getOrderList(query) {
  return request({
    url: '/get_order_list',
    method: 'get',
    params: query,
  })
}

export function downloadFile(params) {
  return request({
    url:'/download_file',
    method:'get',
    responseType: 'blob',
    params
  })
}

export function download_Singlefile(params) {
  return request({
    url: '/download_Sfile',
    method: 'get',
    responseType: 'blob',
    params
  })
}

export function add_invoice_userinfo(data) {
  return request({
    url: '/add_invoice_userinfo',
    method: 'post',
    data
  })
}

export function get_invoice_userinfo() {
  return request({
    url: 'get_invoice_userinfo',
    method: 'get',
  })
} 

export function delete_invoice_userinfo(iname) {
  return request({
    url: '/delete_invoice_userinfo',
    method: 'delete',
    params: { iname },
  })
}

export function download_invoice(params) {
  return request({
    url: '/download_invoice',
    method: 'get',
    responseType: 'blob',
    params
  })
}


// WEBPACK FOOTER //
// ./src/api/orderlist.js